import type { CSSProperties, MouseEventHandler } from 'react'

import { EXPLORE_GLOBE_ICON_URL } from '@/constants/explore'
import { ISuggestion } from '@/types/home'
import { Spinner } from '@cleartrip/ct-design-components'

interface DropDownListProps {
    airportList: ISuggestion[]
    onClick: (arg0: ISuggestion) => void
    onClose: () => void
    loading: boolean
    offsetTop?: string
    rootStyle?: CSSProperties
    onRootMouseDown?: MouseEventHandler<HTMLDivElement>
    showAnywhereOption?: boolean
    onAnywhereClick?: () => void
}

const DropdownList = ({
    airportList,
    onClick,
    onClose,
    loading,
    offsetTop = '52px',
    rootStyle,
    onRootMouseDown,
    showAnywhereOption = false,
    onAnywhereClick = () => {},
}: DropDownListProps) => {
    return (
        <div
            className='dropdown'
            role='listbox'
            style={{
                position: 'absolute',
                top: offsetTop,
                left: 0,
                width: '100%',
                boxSizing: 'border-box',
                ...rootStyle,
            }}
            onMouseDown={onRootMouseDown}
        >
            {loading ? (
                <div className="px-10 py-5 flex flex-center flex-middle">
                    <Spinner />
                </div>
            ) : (
                <>
                    {showAnywhereOption && (
                        <ul className="airportList">
                            <li className="m-1">
                                <div
                                    className="flex flex-middle c-pointer"
                                    onClick={() => {
                                        onAnywhereClick()
                                        onClose()
                                    }}
                                >
                                    <div
                                        className="airport-code br-2 my-2 ml-3 mr-4 bg-neutral-300 c-neutral-700 flex fw-600 pt-1 pb-1 w-10"
                                        style={{ height: '22px', minWidth: '40px' }}
                                    >
                                        <div className="fw-600 flex flex-middle flex-center" style={{ margin: 'auto' }}>
                                            <img
                                                alt=""
                                                height={16}
                                                src={EXPLORE_GLOBE_ICON_URL}
                                                width={16}
                                            />
                                        </div>
                                    </div>
                                    <div className="mr-1 o-hidden" style={{ maxWidth: '100%' }}>
                                        <p className="tt-ellipsis o-hidden fs-14 fw-500">Anywhere</p>
                                        <p className="tt-ellipsis o-hidden fs-2 fw-500 c-neutral-700">
                                            Search for trips to anywhere in the world
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    )}
                    {airportList.map((item, index) => (
                        <ul key={index} className="airportList">
                            <li className="m-1">
                                <div
                                    className="flex flex-middle"
                                    onClick={() => {
                                        onClick(item)
                                        onClose()
                                    }}
                                >
                                    <div
                                        className="airport-code br-2 my-2 ml-3 mr-4 bg-neutral-300 c-neutral-700 flex fw-600 pt-1 pb-1 w-10"
                                        style={{ height: '22px', minWidth: '40px' }}
                                    >
                                        <div className="fw-600" style={{ margin: 'auto', display: 'inline-block' }}>
                                            {item.k}
                                        </div>
                                    </div>
                                    <div style={{ maxWidth: '100%' }} className="mr-1 o-hidden">
                                        <p className="tt-ellipsis o-hidden fs-14 fw-500">{item.v}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    ))}
                </>
            )}
        </div>
    )
}

export default DropdownList
